(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tomkat-book-offer"] && !Shopify.designMode) return;
  try {
    (() => {
  const ids = [65698660712797,65698666152285];
  const eligible = cart => cart.currency === 'GBP' && cart.items.some(i => i.requires_shipping && !ids.includes(i.variant_id)) && !cart.items.some(i => ids.includes(i.variant_id));
  const signature = cart => JSON.stringify(cart.items.map(i => [i.key,i.quantity]).sort());
  class TomkatBookOffer extends HTMLElement {
    static busy = false;
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-book-config]').textContent);
      this.cards = [...this.querySelectorAll('[data-book-id]')];
      this.cards.forEach(card => card.querySelector('button').addEventListener('click', () => this.addBook(card)));
      this.refresh();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
    }
    disconnectedCallback() { this.unsubscribe?.(); }
    url(path) { return this.config.root.replace(/\/?$/, '/') + path; }
    async read(path) {
      const response = await fetch(this.url(path), {credentials:'same-origin',cache:'no-store'});
      if (!response.ok) throw new Error('read');
      return response.json();
    }
    async refresh() {
      const revision = this.revision = (this.revision || 0) + 1;
      try {
        const cart = await this.read('cart.js');
        const products = await Promise.all(this.cards.map(card => this.read('products/' + card.dataset.bookHandle + '.js')));
        if (!this.isConnected || revision !== this.revision) return;
        this.cards.forEach((card, index) => {
          const variant = products[index].variants.find(v => v.id === Number(card.dataset.bookId));
          card.hidden = !eligible(cart) || !variant?.available || variant.price !== 1000;
        });
        this.hidden = this.cards.every(card => card.hidden);
        this.offerSignature = signature(cart);
      } catch { this.hidden = true; }
    }
    async addBook(card) {
      if (TomkatBookOffer.busy || card.hidden) return;
      TomkatBookOffer.busy = true;
      this.querySelectorAll('button').forEach(button => button.disabled = true);
      const modal = document.createElement('dialog');
      modal.className = 'tk-book-progress';
      modal.textContent = this.config.busy;
      modal.addEventListener('cancel', event => event.preventDefault());
      document.body.append(modal);
      modal.showModal();
      try {
        const [before, product] = await Promise.all([this.read('cart.js'),this.read('products/' + card.dataset.bookHandle + '.js')]);
        const id = Number(card.dataset.bookId);
        const variant = product.variants.find(v => v.id === id);
        if (!eligible(before) || signature(before) !== this.offerSignature || !variant?.available || variant.price !== 1000) throw new Error('changed');
        const response = await fetch(this.url('cart/add.js'), {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id,quantity:1}]})});
        if (!response.ok) throw new Error('add');
        const after = await this.read('cart.js');
        const added = after.items.filter(i => i.variant_id === id);
        if (added.reduce((n,i) => n+i.quantity,0) !== 1 || before.items.some(i => !after.items.some(j => j.key === i.key && j.quantity === i.quantity))) throw new Error('verify');
        window.location.assign(this.config.cartUrl);
      } catch {
        this.querySelector('[data-book-status]').textContent = this.config.error;
        this.querySelector('[data-book-review]').hidden = false;
        modal.close(); modal.remove();
        TomkatBookOffer.busy = false;
      }
    }
  }
  if (!customElements.get('tomkat-book-offer')) customElements.define('tomkat-book-offer',TomkatBookOffer);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tomkat-bundle-upgrade"] && !Shopify.designMode) return;
  try {
    (() => {
    const eligible = (cart, config) => {
      if (!cart || cart.currency !== 'GBP' || cart.total_discount > 0) return null;
      if (cart.items.some(i => i.variant_id === config.bundleId)) return null;
      const lines = cart.items.filter(i => config.components.includes(i.variant_id));
      if (!lines.length || lines.length > 2) return null;
      if (new Set(lines.map(i => i.variant_id)).size !== lines.length) return null;
      if (lines.some(i => !i.key || i.quantity < 1 || Object.keys(i.properties || {}).length || i.selling_plan_allocation || i.parent_relationship || i.item_components?.length || i.line_level_total_discount > 0)) return null;
      return lines;
    };
    const signature = cart => JSON.stringify(cart.items.map(i => [i.key, i.quantity]).sort());
    class TomkatBundleUpgrade extends HTMLElement {
      static busy = false;
      connectedCallback() {
        this.config = JSON.parse(this.querySelector('[data-tk-config]').textContent);
        this.querySelector('[data-tk-title]').textContent = this.config.title;
        this.querySelector('[data-tk-description]').textContent = this.config.description;
        this.querySelector('[data-tk-switch]').textContent = this.config.button;
        this.querySelector('[data-tk-switch]').addEventListener('click', () => this.switchBundle());
        this.refresh();
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        }
      }
      disconnectedCallback() { this.unsubscribe?.(); }
      url(path) { return this.config.root.replace(/\/?$/, '/') + path; }
      async read(path) {
        const response = await fetch(this.url(path), { cache:'no-store', credentials:'same-origin' });
        if (!response.ok) throw new Error('read');
        return response.json();
      }
      async refresh() {
        if (TomkatBundleUpgrade.busy) return;
        const revision = this.revision = (this.revision || 0) + 1;
        try {
          const [cart, product] = await Promise.all([this.read('cart.js'), this.read('products/' + this.config.bundleHandle + '.js')]);
          if (revision !== this.revision || !this.isConnected) return;
          const lines = eligible(cart, this.config);
          const variant = product.variants.find(v => v.id === this.config.bundleId);
          if (!lines || !variant?.available) { this.hidden = true; return; }
          const money = n => new Intl.NumberFormat('en-GB', {style:'currency',currency:'GBP'}).format(n / 100);
          const removed = lines.reduce((sum, i) => sum + i.final_price, 0);
          this.offer = { signature:signature(cart), price:variant.price };
          this.querySelector('[data-tk-price]').textContent = (variant.price >= removed ? this.config.priceAdd : this.config.priceSave).replace('[price]', money(variant.price)).replace('[difference]', money(Math.abs(variant.price - removed)));
          this.hidden = false;
        } catch { this.hidden = true; }
      }
      async switchBundle() {
        if (TomkatBundleUpgrade.busy || !this.offer) return;
        TomkatBundleUpgrade.busy = true;
        const button = this.querySelector('[data-tk-switch]');
        button.disabled = true;
        const modal = document.createElement('dialog');
        modal.className = 'tk-bundle-progress';
        modal.textContent = this.config.busy;
        modal.addEventListener('cancel', event => event.preventDefault());
        document.body.append(modal);
        modal.showModal();
        try {
          const [before, product] = await Promise.all([this.read('cart.js'), this.read('products/' + this.config.bundleHandle + '.js')]);
          const lines = eligible(before, this.config);
          const variant = product.variants.find(v => v.id === this.config.bundleId);
          if (!lines || signature(before) !== this.offer.signature || !variant?.available || variant.price !== this.offer.price) throw new Error('changed');
          const updates = Object.fromEntries(lines.map(i => [i.key, i.quantity - 1]));
          updates[this.config.bundleId] = 1;
          const response = await fetch(this.url('cart/update.js'), { method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body:JSON.stringify({updates}) });
          if (!response.ok) throw new Error('update');
          const after = await this.read('cart.js');
          const expected = new Map();
          for (const line of before.items) expected.set(line.variant_id, (expected.get(line.variant_id) || 0) + line.quantity);
          for (const line of lines) expected.set(line.variant_id, line.quantity - 1);
          expected.set(this.config.bundleId, 1);
          const actual = new Map();
          for (const line of after.items) actual.set(line.variant_id, (actual.get(line.variant_id) || 0) + line.quantity);
          if ([...expected].some(([id, quantity]) => (actual.get(id) || 0) !== quantity) || [...actual].some(([id]) => !expected.has(id))) throw new Error('verify');
          window.location.assign(this.config.cartUrl);
        } catch {
          this.querySelector('[data-tk-status]').textContent = this.config.error;
          this.querySelector('[data-tk-review]').hidden = false;
          button.hidden = true;
          modal.close();
          modal.remove();
          TomkatBundleUpgrade.busy = false;
        }
      }
    }
    if (!customElements.get('tomkat-bundle-upgrade')) customElements.define('tomkat-bundle-upgrade', TomkatBundleUpgrade);
  })();
  } catch(e) { console.error(e); }
})();

})();
